import "./styles/styles.scss";
import About from "./Pages/About";
import Home from "./Pages/Home";
import Navbar from "../src/components/Navbar";
import { Route, Routes } from "react-router-dom";
import Models from "./Pages/Models";
import TestimonialsPage from "./Pages/TestimonialsPage";
import Team from "./Pages/Team";
import Contact from "./Pages/Contact";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import FloatingCallButton from "./components/FloatingCallButton";

function App() {
  const phoneNumber = "+918600217396";
  return (
    <>
      <Navbar />
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="models" element={<Models />} />
        <Route path="testimonials" element={<TestimonialsPage />} />
        <Route path="ourservices" element={<Team />} />
        <Route path="contact" element={<Contact />} />
      </Routes>{" "}
      <FloatingWhatsApp
        phoneNumber="918007722929"
        accountName="MyDearCab"
        status="Typically replies within an hour"
        chatMessage="Hello! 👋🏼 How can we help you today?"
        placeholder="Type a message..."
      />
      {/* Floating Call Button (new component) */}
      <FloatingCallButton
        phoneNumber={phoneNumber}
        buttonText="Call MyDearCab"
      />
    </>
  );
}

export default App;
